import { useCustomTranslation } from '../../../../../../hooks';
import { selectOnlyTaskById, useKanbanEventStore } from '../../store';

type LotInfoProps = {
  id: number;
};

export const LotInfo = ({ id }: LotInfoProps) => {
  const task = useKanbanEventStore(selectOnlyTaskById(id));
  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.lotInfo');

  if (!task) {
    return null;
  }

  const { productName, name, progress, externalId } = task;

  const lotNumber = (externalId as { lotNumber?: string }).lotNumber;

  return (
    <div className="flex flex-col gap-y-1 rounded-xs border border-border-container bg-surface-container-lighter px-4 py-3">
      <div className="flex gap-2 text-s11-sb text-text-secondary uppercase">
        <span>{tWrapper('productId')}</span>
        <span>{name}</span>
      </div>
      <p className="flex">
        <span className="text-s16-sb">{productName}</span>
        <span className="ml-auto text-s16-sb"> {progress.totalAmount.amount}</span>
        <span className="ml-2 text-s16">{progress.totalAmount.unit.name}</span>
      </p>
      <div className="flex gap-2 text-s11-sb text-text-secondary uppercase">
        <span>{tWrapper('productionLotId')}</span>
        <span>{lotNumber}</span>
      </div>
    </div>
  );
};
